import type { HttpClient } from '@adapters/HttpClient';
export class ZendeskMessagingApiAdapter {
  constructor(private http: HttpClient) {}
  async credential(): Promise<string | null> {
    const data = await this.http.get<{ jwt?: string; token?: string }>('/zendesk/messaging-jwt', undefined, {}, false);
    return data.jwt ?? data.token ?? null;
  }
}
